exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-sticky-virtscroll-table {\n  /* height or max-height is important */\n  max-height: calc(100vh - 100px);\n}\n.dark {\n  /* this will be the loading indicator */\n}\n.dark thead tr:first-child th {\n  background-color: #2a5c69;\n}\n.dark thead tr th {\n  position: sticky;\n  z-index: 1;\n}\n.dark thead tr:last-child th {\n  /* height of all previous header rows */\n  top: 48px;\n}\n.dark thead tr:first-child th {\n  top: 0;\n}", ""]);

// exports
